import axios from "axios";
import Swal from "sweetalert2";
// const domain = "https://dotdrugtestings.com";  // production domain
// const domain = "https://unifyitconsulting.com"; // staging domain
const domain = "https://drugtest.unifyitc.net"; // staging domain
const baseUri = domain + "/tabapi2";

const uploadDocs = async(path,data)=>{
  console.log("server hit => " + baseUri + path);
  // try {
    // console.log(path);
    // console.log(data);
    const loader = document.getElementById("full-page-loader");
    loader.style.display = "flex";
    const res = await axios.post(baseUri + path, data, {
      headers: {
        'Accept': 'application/json',
            'Content-Type': 'multipart/form-data',
        // "Content-Type": "multipart/form-data",
        // Authorization: "Bearer " + token,
        // "Access-Control-Request-Private-Network": "true",
      },
    }); 
    loader.style.display = "none";
    return res;
}
const postToServer = async (path, data) => {
  console.log("Server hit => " + baseUri + path);
  
  try {
    const loader = document.getElementById("full-page-loader");
    loader.style.display = "flex";
    
    ///console.log("Request Data:", data);
    
    const res = await axios.post(baseUri + path, data, {
      headers: {
        "Content-Type": "application/json",
        // Include other headers if needed
      },
    });

    loader.style.display = "none";
    //console.log("Response Data:", res.data);

    if (res.data && res.data.status) {
      // Successful response
      //console.log("Request successful. Status:", res.data.status);
      return { status: res.data.status, data: res.data.data };
    } else {
      // Error response
      //console.log("Request failed. Response:", res.data);

      Swal.fire({
        title: (res.data && res.data.data && res.data.data.msg) ? res.data.data.msg : 'Something went wrong.',
        icon: "error",
      });

      if (res.data) {
        console.error("Axios response error:", res.data);
        return { status: res.data.status, data: res.data.data };
      } else {
        console.error("Axios response error: No data");
        return { status: false, data: {} };
      }
    }
  } catch (error) {
    console.error("Request error:", error);
    Swal.fire({ title: error.message || 'Something went wrong', icon: "error" });
    return { status: false, data: {} };
  }
};

const licenseDetailApi = async (data) => {
  const url = domain + "/tablet/tabmvr/webmvrapi";
  console.log("server hit => " + url);
  try {
    const res = await axios.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        // Authorization: "Bearer " + token,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Request-Private-Network": "true",
      },
    });
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
const getCompanies = async () => {
  const url = domain + "/tablet/Tabmvr/getAllCompaniesjson";
  console.log("server hit => " + url);
  try {
    const res = await axios.get(url, {
      headers: {
        // "Content-Type": "multipart/form-data",
        // Authorization: "Bearer " + token,
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Request-Private-Network": "true",
      },
    });
    return res.data;
  } catch (error) {
    return [];
  }
};

const getDriverDocumentTypes = async (currentStep,pageNo) => {
	let path = "/getDriverDocumentTypes/"+currentStep;
	if (pageNo !== undefined){
		path = "/getDriverDocumentTypes/"+currentStep+'?pageno='+pageNo;
	}	
  console.log("server hit => " + baseUri + path);
  try {
    const res = await axios.get(baseUri + path, {
      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + token,
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Request-Private-Network": "true",
      },
    });
    //console.log("res.data",res.data)
    return res.data;
   
  } catch (error) {
    return [];
  }
};

// swal({
//   position: "top-end",
//   title: res.data.data.msg,
//   icon: "success",
//   timer: 1500,
// });

const finalSubmitToServer = async (data) => {
  const path = "/finalSubmit";
  console.log("Server hit => " + baseUri + path);
  
  try {
    const loader = document.getElementById("full-page-loader");
    loader.style.display = "flex";
    
    ///console.log("Request Data:", data);
    
    const res = await axios.post(baseUri + path, data, {
      headers: {
        "Content-Type": "application/json",
        // Include other headers if needed
        // "Authorization": "Bearer " + token,
        // "Access-Control-Request-Private-Network": "true",
      },
    });

    loader.style.display = "none";
    //console.log("Response Data:", res.data);

    if (res.data && res.data.status) {
      // Successful response
      console.log("Request successful. Status:", res.data.status);
      return { status: res.data.status, msg: res.data.data.msg };
    } else {
      // Error response
      console.log("Request failed. Response:", res.data);
      console.error("Axios response error:", res.data);
      return { status: false, msg: "Something went wrong" };
    }
  } catch (error) {
    // Exception handling
    console.error("Request error:", error);
    return { status: false, msg: "Something went wrong" };
  }
};


const checkMvrPassToServer = async (data) => {
  const url = domain + "/tablet/Tabmvr/checkMvrPassword";
  console.log("server hit => " + url);
  try {
    // const loader = document.getElementById("full-page-loader");
    // loader.style.display = "flex";
    const res = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + token,
        "Access-Control-Request-Private-Network": "true",
      },
    });
    // loader.style.display = "none";
    // console.log(res);
    return { status: res.data.status, msg: res.data.data.msg };
  } catch (error) {
    return { status: false, msg: "Something went wrong" };
  }
};

const tabLogin = async (data)=>{
  const url = baseUri+"/tabLogin";
  console.log("server hit => " + url);
  try {
    // const loader = document.getElementById("full-page-loader");
    // loader.style.display = "flex";
    const res = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + token,
        // "Access-Control-Request-Private-Network": "true",
      },
    });
    // loader.style.display = "none";
    // console.log(res);
    return { status: res.data.status, msg: res.data.data.msg };
  } catch (error) {
    return { status: false, msg: "Something went wrong" };
  }
}

export { postToServer, licenseDetailApi, getCompanies, finalSubmitToServer, checkMvrPassToServer, tabLogin, getDriverDocumentTypes, uploadDocs };

// mobiscroll config react
